export const seniorAccountantResume = `
【職務概要】
会計・経理分野において15年以上のキャリアを積み、決算業務、経営分析、予算策定から内部統制管理まで幅広い実務経験を有しています。特に製造業の経理実務に精通し、国際会計基準（IFRS）に基づく連結決算の主導や業績管理体制の構築に強みを持っています。近年は経理部門のリーダーとして、経理業務のDX推進や業務効率化に注力し、経理システムの刷新やペーパーレス化によるコスト削減を実現してきました。

また、経理部門の戦略的パートナーとしての役割を重視し、単なる数字の管理を超えて、経営判断に資する分析情報の提供や、部門横断的な改善施策の提案にも積極的に取り組んでいます。税務・会計の専門性を追求するとともに、業務プロセスの最適化や人材育成の観点からも組織に貢献できる経理のプロフェッショナルを目指しています。

【職務経歴】
○ 株式会社Algomatic精密（自動車部品製造業、従業員約800名）
  2015年4月〜現在
  ＜会社概要＞
  自動車用精密部品の製造・販売を行うグローバル企業。アジア、欧州に生産拠点を持ち、年商約800億円。

  ＜職務内容＞
  ・経理財務部 マネージャーとして9名の経理チームを統括
  ・連結決算管理（IFRS基準）および開示資料作成の責任者
  ・経営層向け月次業績レポートの作成・報告
  ・予算策定、中期経営計画策定における財務面のサポート
  ・資金調達計画の立案および金融機関との折衝
  ・グローバル経理システムの導入プロジェクトリーダー

  ＜成果＞
  ・経理業務の標準化により決算期間を7営業日から5営業日に短縮
  ・SAPシステム導入により業績管理精度が向上し、予実差異分析の質が大幅に改善
  ・海外子会社の経理業務標準化により、連結決算の正確性が向上（決算修正項目が前年比40%減少）
  ・資金調達コストの見直しにより年間財務コストを約3,500万円削減
  ・税務戦略の最適化により、実効税率を2.3%改善

  ＜使用ツール・習得スキル＞
  ・SAP ERP（財務会計モジュール）
  ・連結会計パッケージ（DivaSystem）
  ・Power BI によるデータ分析・可視化
  ・IFRS会計基準に基づく財務報告スキル
  ・グローバルチームマネジメントスキル
  ・英語による国際財務報告能力

○ 株式会社Algomaticエネルギーソリューションズ（エネルギー関連商社、従業員約500名）
  2010年6月〜2015年3月
  ＜会社概要＞
  石油製品および再生可能エネルギー関連機器の販売、エネルギー事業コンサルティングを行う総合商社。

  ＜職務内容＞
  ・経理部 主任として経理実務全般を担当
  ・月次・四半期・年次決算業務のとりまとめ
  ・税務申告書作成および税務調査対応
  ・予算策定および予算実績管理
  ・内部統制評価（J-SOX）の実務責任者

  ＜成果＞
  ・財務会計業務の効率化により経理部人員を1名削減しつつ業務品質を維持
  ・経理システム更新プロジェクトを主導し、予算比100万円のコスト削減を実現
  ・J-SOX対応の業務プロセス見直しにより、内部統制上の不備事項をゼロに
  ・会計監査への対応改善により監査工数を前年比20%削減

  ＜使用ツール・習得スキル＞
  ・会計システム（Oracle EBS）
  ・Excel VBAによる業務自動化
  ・内部統制評価・文書化手法
  ・税務申告実務（法人税、消費税、法人住民税等）
  ・経営管理会計スキル

○ 株式会社Algomatic総合コンサルティング（コンサルティングファーム、従業員約200名）
  2007年4月〜2010年5月
  ＜会社概要＞
  財務・会計・人事・ITなど幅広い分野のビジネスコンサルティングを提供する企業。

  ＜職務内容＞
  ・経理財務部 担当者として経理実務を担当
  ・会計処理業務（仕訳入力、伝票処理、支払管理等）
  ・小口現金管理、経費精算業務
  ・月次決算書類作成
  ・業績分析資料の作成

  ＜成果＞
  ・経費精算プロセスの電子化を提案・実行し、処理時間を50%削減
  ・部門別収支管理の仕組みを構築し、プロジェクト採算性の可視化に貢献
  ・社内研修で経理知識普及に努め、非経理部門からの問い合わせ件数を30%削減

  ＜使用ツール・習得スキル＞
  ・会計システム（PCA会計）
  ・Excelによる財務分析スキル
  ・基本的な会計実務スキル
  ・コミュニケーション能力

【受賞・表彰歴】
・2022年度 株式会社Algomatic精密 MVP賞受賞（経理DX推進による業務効率化が評価）
・2019年度 同社 業務改革優秀賞受賞（海外子会社の経理プロセス標準化プロジェクトが評価）
・2016年度 同社 チームワーク賞受賞（システム導入チームの統括実績が評価）
・2014年度 株式会社Algomaticエネルギーソリューションズ 社長賞受賞（J-SOX対応による内部統制強化が評価）

【資格】
・公認会計士（2015年登録）
・税理士（2017年登録、税法科目全科目合格）
・日商簿記1級（2009年3月取得）
・米国公認管理会計士（CMA）（2019年6月取得）
・FP2級（2012年9月取得）
・TOEIC 830点（2022年6月）

【マネジメント経験】
・現職にて経理財務部マネージャーとして9名のチームをマネジメント（2015年4月〜現在）
・経理メンバーの採用、育成、評価を担当
・業務の標準化と効率化により、業務量増加にも関わらず残業時間を部門平均で月20時間から12時間に削減
・部門内でのナレッジ共有会を月1回実施し、専門性向上とチーム力強化を実現
・グローバル経理システム導入プロジェクトでは15名の多国籍チームをリード

【語学力】
・英語：ビジネスレベル（TOEIC 830点）
業務での使用経験：海外子会社との経理打ち合わせ、財務報告書の英文作成、外国人役員への業績報告、海外監査法人との折衝
` as const;
